var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 6,
    viewBox: "0 0 12 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.41602 5.91668H3.08268C2.27574 5.91668 1.58789 5.6323 1.01914 5.06355C0.450391 4.4948 0.166016 3.80695 0.166016 3.00001C0.166016 2.19307 0.450391 1.50522 1.01914 0.936469C1.58789 0.367718 2.27574 0.0833435 3.08268 0.0833435H5.41602V1.25001H3.08268C2.59657 1.25001 2.18338 1.42015 1.8431 1.76043C1.50282 2.1007 1.33268 2.5139 1.33268 3.00001C1.33268 3.48612 1.50282 3.89932 1.8431 4.23959C2.18338 4.57987 2.59657 4.75001 3.08268 4.75001H5.41602V5.91668ZM3.66602 3.58334V2.41668H8.33268V3.58334H3.66602ZM6.58268 5.91668V4.75001H8.91602C9.40213 4.75001 9.81532 4.57987 10.1556 4.23959C10.4959 3.89932 10.666 3.48612 10.666 3.00001C10.666 2.5139 10.4959 2.1007 10.1556 1.76043C9.81532 1.42015 9.40213 1.25001 8.91602 1.25001H6.58268V0.0833435H8.91602C9.72296 0.0833435 10.4108 0.367718 10.9796 0.936469C11.5483 1.50522 11.8327 2.19307 11.8327 3.00001C11.8327 3.80695 11.5483 4.4948 10.9796 5.06355C10.4108 5.6323 9.72296 5.91668 8.91602 5.91668H6.58268Z",
    fill: "#000A8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.fe30e6df.svg";
export { ForwardRef as ReactComponent };